import { combineReducers } from 'redux';
import Layout from './layout/reducers';
import Auth from './auth/reducers';
import Filters from './filters/reducers';

export default combineReducers({
    Auth,
    Layout,
    Filters,
});
